import { render } from "./ShareAction.vue?vue&type=template&id=07b2fa3f"
import script from "./ShareAction.vue?vue&type=script&lang=js"
export * from "./ShareAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__